<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      ref="my-table"
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <!-- <span v-if="props.column.field === 'fullname'" class="text-nowrap">
          
          <span class="text-nowrap">{{ props.row.fullname }}</span>
        </span> -->

        <!-- Column: Name -->
        <span v-if="props.column.field === 'province'" class="text-nowrap">
          <span>
            <span class="text-nowrap">{{ props.row.areaDescription }}</span>
            <span
              v-if="
                props.row.provinceDescription !== null &&
                  props.row.provinceDescription !== undefined &&
                  props.row.provinceDescription !== ''
              "
              class="text-nowrap"
              ><br />/{{ props.row.provinceDescription }}</span
            >
          </span>
        </span>

        <span
          v-else-if="props.column.field === 'provinceManage'"
          class="text-nowrap"
        >
          <span>
            <b-button
              @click="onProvinceManageBtnClicked(props.row)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="text-body align-middle mr-25"
            >
              <feather-icon icon="MenuIcon" class="mr-50" />
              <span class="align-middle">สิทธิ์</span>
            </b-button>
          </span>
        </span>

        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item @click="onManageBtnClicked(props.row.roleId)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>แก้ไข</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="props.row.notDelete === false"
                @click="onDeleteBtnClicked(props.row.roleId)"
              >
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>ลบ</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <ModalProvinceManage
      @handle-submit="onProvinceManageSubmit"
      ref="modal-province-manage"
    />
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import ModalProvinceManage from "./ModalProvinceManage";

import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./roleUserTableHeader.js";
import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
    VueSelect,
    ModalProvinceManage,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    // console.log('props', props)
    // return {
    //   tabMode: props.mode,
    //   rows: props.users,
    // };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      provinces: [],
      areas: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      provincialUserIdUpper: "25E8AF7C-D072-47FD-985B-FB1EEFC44764",
      provincialUserIdLower: "25e8af7c-d072-47fd-985b-fb1eefc44764",
      areaUserIdUpper: "F222BEBD-9F10-4832-BFDB-18CB0E0311A2",
      areaUserIdLower: "f222bebd-9f10-4832-bfdb-18cb0e0311a2",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    //this.onSearchSubmit({});
    const _this = this;

    if (
      this.$route.query.id === this.provincialUserIdUpper ||
      this.$route.query.id === this.provincialUserIdLower ||
      this.$route.query.id === this.areaUserIdUpper ||
      this.$route.query.id === this.areaUserIdLower
    ) {
      TableHeaders.push({
        label: "ภูมิภาค",
        field: "province",
      });

      TableHeaders.push({
        label: "จัดการ",
        field: "provinceManage",
      });
    }
  },
  methods: {
    onSearchSubmit() {
      const _this = this;

      const params = {
        roleId: this.$route.query.id,
      };

      roleStore
        .getRoleUserList(params)
        .then((response) => {
          //console.log("response", response.data.data);
          var users = response.data.data;
          _this.rows = users;
          //console.log('_this.$route.query.id', _this.$route.query.id)

          if (
            _this.$route.query.id === _this.provincialUserIdUpper ||
            _this.$route.query.id === _this.provincialUserIdLower
          ) {
            storeMaster.getProvince().then((response) => {
              _this.provinces = response.data.data;

              _this.updateRowsProvinceDescription();
            });

            storeMaster.getArea().then((response) => {
              _this.areas = response.data.data;

              _this.updateRowsAreaDescription();
            });
          } else if (
            _this.$route.query.id === _this.areaUserIdUpper ||
            _this.$route.query.id === _this.areaUserIdLower
          ) {
            storeMaster.getArea().then((response) => {
              _this.areas = response.data.data;

              _this.updateRowsAreaDescription();
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    updateRowsProvinceDescription() {
      const _this = this;
      _this.rows.forEach((value) => {
        const province = _this.provinces.find((prov) => {
          return value.province === prov.value;
        });

        if (province !== null && province !== undefined) {
          value.provinceDescription = province.text;
        } else {
          value.provinceDescription = "";
        }
      });
    },
    updateRowsAreaDescription() {
      const _this = this;
      _this.rows.forEach((value) => {
        const area = _this.areas.find((a) => {
          return value.area === a.value;
        });

        if (area !== null && area !== undefined) {
          value.areaDescription = area.text;
        } else {
          value.areaDescription = "";
        }
      });
    },
    selectionChanged() {
      //console.log("ref", this.$refs["my-table"].selectedRows);
      this.$forceUpdate();
      this.$emit("handle-select", this.$refs["my-table"].selectedRows);
    },
    onMenuBtnClicked(id) {
      window.open(
        this.$router.resolve({ name: "RoleMenu", query: { id } }).href,
        "_blank"
      );
    },
    onManageBtnClicked(id) {
      window.open(
        this.$router.resolve({ name: "RoleManage", query: { id } }).href,
        "_blank"
      );
    },
    onProvinceManageBtnClicked(user) {
      // this.fullname = user.fullname;
      // this.userId = user.userId;
      // this.areaCode = user.areaCode;
      // this.provinceCode = user.provinceCode;
      // this.districtCode = user.districtCode;
      // this.subDistrictCode = user.subDistrictCode;
      const _this = this

      this.$refs["modal-province-manage"].$refs["modal-province-manage"].show();
      if (
        _this.$route.query.id === _this.areaUserIdUpper ||
        _this.$route.query.id === _this.areaUserIdLower
      ) {
        this.$refs["modal-province-manage"].onShow(user, 1);
      } else if (
        _this.$route.query.id === _this.provincialUserIdUpper ||
        _this.$route.query.id === _this.provincialUserIdLower
      ) {
        this.$refs["modal-province-manage"].onShow(user, 2);
      }

      
    },
    onProvinceManageSubmit(user) {
      const _this = this;

      //console.log("onProvinceManageSubmit", user.userId, user.area, user.province, user.district, user.subDistrict);

      roleStore
        .updateRoleUserProvince(
          this.$route.query.id,
          user.userId,
          user.area,
          user.province,
          user.district,
          user.subDistrict
        )
        .then((response) => {
          if (response.data.success === true) {
            this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            _this.$refs["modal-province-manage"].$refs[
              "modal-province-manage"
            ].hide();

            console.log("response data", response.data.data);

            _this.rows.forEach((value) => {
              if (value.userId === response.data.data.userId) {
                value.area = response.data.data.area;
                value.province = response.data.data.province;
                value.district = response.data.data.district;
                value.subDistrict = response.data.data.subDistrict;
              }
            });

            _this.updateRowsProvinceDescription();
            _this.updateRowsAreaDescription();
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        });
    },
    onDeleteBtnClicked(id) {
      const _this = this;

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          roleStore
            .deleteItem(id)
            .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                this.onSearchSubmit({});
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
